import {
  takeLatest, put, call, select,
} from 'redux-saga/effects';
import actionTypes2 from 'store/table2/actionTypes2';
import api from 'store/api';
import { toast } from 'react-toastify';
import { URL } from '../../../constants/url';
import {
  getBb, getStake, getTs, getCard1, getCard2, getSuit,
} from '../selectors';
import { setSecondPairCardTableFold2 } from '../actions';

export function* setSecondPair2(payload) {
  const ts = yield select(getTs);
  const stake = yield select(getStake);
  const bb = yield select(getBb);
  const card1 = yield select(getCard1);
  const card2 = yield select(getCard2);
  const suit = yield select(getSuit);

  try {
    const res = yield call(api, {
      method: 'post',
      url: URL.PLO5SECOND_PAIR,
      data: {
        ts,
        // eslint-disable-next-line no-nested-ternary
        bb: ts !== 'mtt' ? (stake.includes('0') ? 'rfivssqz' : bb) : `${bb}potopen`,
        stake,
        easy: payload.easy,
        game: payload.gameTable,
        card1,
        card2,
        suit,
        smart_range: payload.smartRange,
      },
    });

    const { data } = res;
    yield put(setSecondPairCardTableFold2.success({
      cells: data?.cells,
      purple: data?.purple,
    }));
  } catch (e) {
    yield call(toast.error, e.message);
    yield put(setSecondPairCardTableFold2.error({
      e,
    }));
  }
}

export default function* listener() {
  yield takeLatest(actionTypes2.SET_SECOND_PAIR_2, setSecondPair2);
}
